// extracted by css-extract-rspack-plugin
export default {"item":"_9a0f2f95"};